export default "__VITE_ASSET__DQduu9xD__"